import { useEffect, useRef } from 'react'
import {
  isCartIdentityStorageKey,
  readStoredCartId,
  readStoredCustomerUserId,
} from '../cartPersistence'

type IdentitySnapshot = {
  userId: string | null
  cartId: string | null
}

export const useCartIdentitySync = ({
  refreshCart,
}: {
  refreshCart: () => Promise<void>
}) => {
  const identityRef = useRef<IdentitySnapshot>({
    userId: null,
    cartId: null,
  })

  useEffect(() => {
    identityRef.current = {
      userId: readStoredCustomerUserId(),
      cartId: readStoredCartId(),
    }
  }, [])

  useEffect(() => {
    const syncIdentity = () => {
      const nextIdentity = {
        userId: readStoredCustomerUserId(),
        cartId: readStoredCartId(),
      }
      const currentIdentity = identityRef.current
      if (
        nextIdentity.userId === currentIdentity.userId &&
        nextIdentity.cartId === currentIdentity.cartId
      ) {
        return
      }

      identityRef.current = nextIdentity
      void refreshCart()
    }

    const onStorage = (event: StorageEvent) => {
      if (isCartIdentityStorageKey(event.key)) {
        syncIdentity()
      }
    }

    const onAuthChanged = () => {
      syncIdentity()
    }

    window.addEventListener('storage', onStorage)
    window.addEventListener('emporion:customer-auth-changed', onAuthChanged)
    return () => {
      window.removeEventListener('storage', onStorage)
      window.removeEventListener('emporion:customer-auth-changed', onAuthChanged)
    }
  }, [refreshCart])
}
